export default {
      id: "rain-usage",
      viewBox: "0 0 12.665 11.591",
      url: __webpack_public_path__ + "img/icons.df114aed.svg#rain",
      toString: function () {
        return this.url;
      }
    }